import React from 'react';

import platform from '@lyearn/core/utils/Platform';
import { CheckmarkOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Avatar, BaseButton, Checkbox, Stack, Typography } from '@lyearn/ui';

import { FilterItemProps } from './types';

export default function FilterItemMobile(props: FilterItemProps) {
  const { option, isSelected, onClick, isSingleSelect, itemRenderer, className } = props;

  const isNative = platform.OS !== 'web';

  const _onClick = React.useCallback(() => {
    onClick?.(option);
  }, [onClick, option]);

  const defaultItemRenderer = React.useCallback(
    () => (
      <>
        {option.Icon ? (
          <Stack alignItems="center" className="h-24 w-24 me-16" justifyContent="center">
            <option.Icon className="h-24 w-24" fillColorToken="icon-primary" />
          </Stack>
        ) : option.src !== undefined ? (
          <Avatar size="x-large" src={option.src} />
        ) : null}
        <Typography
          className="overflow-hidden text-ellipsis whitespace-nowrap"
          color="text-text-primary"
          numberOfLines={isNative ? 1 : undefined}
          title={option.label}
          variant="body-short-01">
          {option.label}
        </Typography>
      </>
    ),
    [isNative, option],
  );

  const renderSelectedAction = () => {
    if (!isSingleSelect) {
      return (
        <Checkbox
          checked={!!isSelected}
          className="h-24 min-w-0 bg-bg-primary p-0"
          disabled={option.disabled}
          size="large"
        />
      );
    }

    if (isSelected) {
      return <CheckmarkOutline className="h-16 w-16 flex-shrink-0" />;
    }

    return null;
  };

  return (
    <BaseButton
      className={cn(
        'mb-4 flex w-full items-center justify-between rounded-8 py-14 px-12',
        {
          'pointer-events-none opacity-50': option.disabled,
        },
        className,
      )}
      onClick={option.disabled ? undefined : _onClick}>
      <Stack alignItems="center" className="w-full" justifyContent="between">
        <Stack alignItems="center" className="w-[86%]">
          {itemRenderer
            ? itemRenderer({
                option,
                isSelected,
              })
            : defaultItemRenderer()}
        </Stack>
        {renderSelectedAction()}
      </Stack>
    </BaseButton>
  );
}
